export const types = {
    THREADSCOPE: 'THREAD-SCOPE',
    RUN: 'RUN',
    MESSAGE: 'MESSAGE'
};
